browserDetection();

/**
 * Checks the user agent against the given regexp.
 *
 * @param regEx
 * @returns {boolean}
 * @private
 */
function _checkUserAgent(regEx) {
  console.log('navigator.userAgent', navigator.userAgent);
  return !!navigator.userAgent.toLowerCase().match(regEx);
}

/**
 * Detects the browser type and adds specific css classes to the html tag.
 *
 * @private
 */
function browserDetection() {
  var $html = $('html');
  const detections = {};

  detections['is--edge'] = _checkUserAgent(/edge\//);
  detections['is--opera'] = _checkUserAgent(/opera/);
  detections['is--chrome'] = !detections['is--edge'] && _checkUserAgent(/\bchrome\b/);
  detections['is--firefox'] = _checkUserAgent(/firefox/);
  detections['is--webkit'] = !detections['is--edge'] && _checkUserAgent(/webkit/);
  detections['is--safari'] =
    !detections['is--edge'] && !detections['is--chrome'] && _checkUserAgent(/safari/);
  detections['is--ie'] =
    !detections['is--opera'] && (_checkUserAgent(/msie/) || _checkUserAgent(/trident\/7/));
  detections['is--ie-touch'] = detections['is--ie'] && _checkUserAgent(/touch/);
  detections['is--gecko'] = !detections['is--webkit'] && _checkUserAgent(/gecko/);

  $.each(detections, function (key, value) {
    if (value) $html.addClass(key);
  });
}
